module.exports = __webpack_public_path__ + "img/media-2.c1a523fc.jpg";